import React from "react";
import { CircleAlert } from "lucide-react";

/**
 * DS NoticeBox — figma "Notification box-gray" 3845:56095 / "Notification box-white" 3957:70860 /
 *   bullet 형 4390:52367("동기화 항목").
 *   p12, radius 8, row gap 6, items-start. 아이콘 칸 22×22 안에 16px 아이콘(Text/Accent).
 *   제목 SemiBold 14/22 Text/Primary. 줄 Regular 14/22 Text/Secondary, 줄 간격 6. <strong> = Bold.
 *   bullet 줄: disc, padding-left 21.
 *
 * @param {object} props
 * @param {"gray"|"white"} [props.tone="gray"] - gray = #F9FAFB, white = BG/White
 * @param {React.ReactNode} [props.title] - 박스에는 타이틀 줄을 두는 것이 기본(4279:146648 "… 확인사항").
 *   짧은 안내 한 문장은 문장 전체를 타이틀로 둘 수 있다(5079:171662)
 * @param {Array<React.ReactNode>} [props.items] - bullet 줄
 * @param {React.ReactNode} [props.children] - 일반 줄. 배열/복수 children 이면 줄마다 wrap. 링크는 <a className="ds-notice-box__link">
 * @param {string} [props.className]
 */
const DSNoticeBox = ({ tone = "gray", title, items, children, className = "" }) => (
  <div className={`ds-notice-box ds-notice-box--${tone} ${className}`}>
    <span className="ds-notice-box__icon-wrap" aria-hidden>
      <CircleAlert size={16} />
    </span>
    <div className="ds-notice-box__body">
      {title ? <div className="ds-notice-box__title">{title}</div> : null}
      {React.Children.map(children, (child) =>
        child === null || child === undefined || child === false ? null : (
          <div className="ds-notice-box__line">{child}</div>
        ),
      )}
      {items && items.length ? (
        <ul className="ds-notice-box__items">
          {items.map((item, idx) => (
            <li key={idx}>{item}</li>
          ))}
        </ul>
      ) : null}
    </div>
  </div>
);

export default React.memo(DSNoticeBox);
